import React from 'react';
import SEO from '../../../../components/SEO/SEO';

import { Link } from 'react-router-dom';
import './WebDevHealthcare.css';

const WebDevHealthcare = () => {
    const healthcareWebDevServices = [
        {
            id: 'hipaa-compliant',
            icon: '🏥',
            title: 'HIPAA-Compliant Web Design',
            description: 'Build patient-friendly websites that meet HIPAA requirements and build trust with secure, compliant design.',
            link: '/services/web-development/custom'
        },
        {
            id: 'appointment-booking',
            icon: '📅',
            title: 'Online Appointment Booking',
            description: 'Integrate seamless appointment scheduling systems that work with your existing practice management software.',
            link: '/services/web-development/custom'
        },
        {
            id: 'patient-portal',
            icon: '🔐',
            title: 'Patient Portal Integration',
            description: 'Connect your website with patient portals for secure access to medical records and communication.',
            link: '/services/web-development/custom'
        },
        {
            id: 'mobile-responsive',
            icon: '📱',
            title: 'Mobile-Responsive Design',
            description: 'Ensure your healthcare website works perfectly on all devices with mobile-first design principles.',
            link: '/services/web-development/custom'
        }
    ];

    return (
        <div className="seo-services-page">
            <SEO 
                title="Web Dev Healthcare Services | Digi Network" 
                description="Learn more about our Web Dev Healthcare services to grow your business online with Digi Network." 
                canonical="/industries/healthcare/services/webdevhealthcare" 
            />

            {/* Hero Section */}
            <section className="seo-hero">
                <div className="seo-hero-bg"></div>
                <div className="container">
                    <div className="seo-hero-content">
                        
                        <h1>Web Development Services for Healthcare Practices</h1>
                        <p className="industry-service-hero-description">Build patient-friendly websites that build trust, showcase expertise, and convert visitors into appointments. Our healthcare-focused web development creates digital experiences that convert visitors into patients while maintaining HIPAA compliance.</p>
                        <div className="industry-service-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                            Get Free Website Audit
                            <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                            </svg>
                        </Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* Healthcare Web Dev Services Grid */}
            <section className="seo-services-grid-section">
                <div className="container">
                    <h2>Our Healthcare Web Development Services</h2>
                    <p>Comprehensive web development solutions designed specifically for healthcare practices</p>

                    <div className="seo-services-grid">
                        {healthcareWebDevServices.map((service) => (
                            <Link to={service.link} key={service.id} className="seo-service-card">
                                <div className="seo-service-icon">{service.icon}</div>
                                <h3>{service.title}</h3>
                                <p>{service.description}</p>
                                <div className="learn-more">
                                    Learn More
                                    <svg width="20" height="20" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="currentColor"/>
                                    </svg>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>

            {/* Why Healthcare Web Development Matters */}
            <section className="why-seo-matters">
                <div className="container">
                    <div className="why-seo-content">
                        <div className="why-seo-text">
                            <h2>Why Web Development is Essential for Healthcare Practices</h2>
                            <div className="why-seo-points">
                                <div className="why-point">
                                    <h4>🏥 Patient Trust & Credibility</h4>
                                    <p>A professional website builds trust and credibility with patients, making them more likely to choose your practice.</p>
                                </div>
                                <div className="why-point">
                                    <h4>📅 Convenient Appointment Booking</h4>
                                    <p>Online appointment scheduling makes it easier for patients to book appointments and reduces administrative burden.</p>
                                </div>
                                <div className="why-point">
                                    <h4>🔒 HIPAA Compliance</h4>
                                    <p>Ensure patient data security and maintain compliance with healthcare regulations through proper web development.</p>
                                </div>
                                <div className="why-point">
                                    <h4>📱 Mobile Accessibility</h4>
                                    <p>Reach patients on all devices with mobile-responsive design that works perfectly on smartphones and tablets.</p>
                                </div>
                            </div>
                        </div>
                        <div className="why-seo-visual">
                            <div className="seo-visual-placeholder">
                                <p>🖼️ Add Healthcare Web Dev Impact Graphic</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Process Section */}
            <section className="seo-process">
                <div className="container">
                    <div className="section-header">
                        <div className="label">OUR PROCESS</div>
                        <h2>Our Web Development Process</h2>
                        <p>A proven methodology designed specifically for healthcare businesses</p>
                    </div>

                    <div className="process-grid">
                        <div className="process-step">
                            <div className="process-number">01</div>
                            <h3>Discovery & Planning</h3>
                            <p>Understand your goals, audience, and requirements to create the perfect solution.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">02</div>
                            <h3>Design & Development</h3>
                            <p>Create beautiful designs and develop with modern, scalable technologies.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">03</div>
                            <h3>Testing & Launch</h3>
                            <p>Rigorous testing across devices and browsers before a smooth launch.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">04</div>
                            <h3>Support & Optimization</h3>
                            <p>Ongoing maintenance, updates, and performance optimization.</p>
                        </div>
                    </div>
                </div>
            </section>


            {/* Healthcare Web Dev Process */}

            {/* CTA Section */}
            <section className="industry-service-cta">
                <div className="container">
                    <h2>Ready to Build a Patient-Friendly Healthcare Website?</h2>
                    <p>Get a free website audit and discover how we can help you create a website that builds trust and drives appointments.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Get Your Free Website Audit
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default WebDevHealthcare;
